import { Column, PrimaryGeneratedColumn } from 'typeorm';

export class BasicAttempts {
  @PrimaryGeneratedColumn()
  id: number;

  @Column({ type: 'varchar', nullable: false, unique: true })
  ip: string;

  @Column({ type: 'int', nullable: false, default: 0 })
  passwordAttempts: number;

  @Column({
    nullable: true,
    type: 'timestamptz',
    precision: 3,
  })
  blockedUntil: Date | null;
}
